var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('div',{staticClass:"header"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.edit}},[_vm._v(" 编辑 ")])],1),_c('info-panel',{attrs:{"padding":24}},[_c('el-row',[_c('el-col',[_c('info-item',{attrs:{"label":"考试须知"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.result.examPurchaseNotice)}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }